import { EbanxTokenResponse } from 'Jsx/CheckoutV4/types/Ebanx';

import { CardHolderSate } from '../../../../UserInputFields/CardHolderInput/CardHolderInput';
import { CreditCardState } from '../../../../UserInputFields/CreditCardInput/CreditCardInput';

export interface EbanxToken {
  deviceId: string;
  token: string;
  maskedCardNumber: string;
  error: string;
}

const ebanxResponseHandler = (response: EbanxTokenResponse) => {
  if (response.data && response.data.status) {
    const {
      deviceId,
      token,
      masked_card_number: maskedCardNumber,
    } = response.data;

    return { deviceId, token, maskedCardNumber, error: '' };
  }
  return {
    error: response.error.err.status_message,
    deviceId: '',
    token: '',
    maskedCardNumber: '',
  };
};

export function getEbanxToken({
  creditCard,
  countryPrefix,
  cardHolder,
}: {
  creditCard: CreditCardState;
  cardHolder: CardHolderSate;
  countryPrefix: string;
}) {
  return new Promise<EbanxToken>((resolve, _) => {
    if (window.EBANX_DEBUG === 'True') {
      window.EBANX.config.setMode('test');
    } else {
      window.EBANX.config.setMode('production');
    }
    window.EBANX.config.setPublishableKey(window.EBANX_PUBLIC_INTEGRATION_KEY);
    window.EBANX.config.setCountry(countryPrefix);
    const dateString = creditCard.expiration.split('/');

    const expMonth = dateString[0];
    const expYear = dateString[1];

    const card = {
      card_number: creditCard.number.replace(/\s+/g, ''),
      card_name: cardHolder.name,
      card_due_date: `${expMonth}/20${expYear}`,
      card_cvv: creditCard.cvc,
    };

    window.EBANX.card.createToken(card, (response: EbanxTokenResponse) =>
      resolve(ebanxResponseHandler(response)),
    );
  });
}
